export default "__VITE_ASSET__jrYQ$SRG__"